// @core/stores/booking/BookingResourceStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  BookableResourceResponse,
  CreateResourceRequest,
  ListResourcesResponse,
  SetResourceStatusRequest,
  UpdateResourceRequest,
} from '@core/types/booking';

class BookingResourceStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Create bookable resource
   */
  async CreateResource(data: CreateResourceRequest): Promise<BookableResourceResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.CreateResource(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Delete bookable resource
   */
  async DeleteResource(resource_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.DeleteResource(resource_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get bookable resource
   */
  async GetResource(resource_id: string): Promise<BookableResourceResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.GetResource(resource_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List bookable resources
   */
  async ListResources(params?: { booking_type_id?: string | number | boolean; cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; q?: string | number | boolean; sort?: string | number | boolean; status?: string | number | boolean; }): Promise<ListResourcesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ListResources(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Set resource status
   */
  async SetResourceStatus(resource_id: string, data: SetResourceStatusRequest): Promise<BookableResourceResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.SetResourceStatus(resource_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update bookable resource
   */
  async UpdateResource(resource_id: string, data: UpdateResourceRequest): Promise<BookableResourceResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.UpdateResource(resource_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingResourceStore = new BookingResourceStore();
